import { gql } from "apollo-boost"

export const getSpecificObjectives = gql`
query SubmissionObjectives($id: ID!) {
  SubmissionObjectives(id: $id) {
    specificObjectives {
      id
      description
      orderIndex
      activities {
        id
        isBlocking
        goal
        title
        orderIndex
        description
      }
    }
  }
}
`
